import { render, staticRenderFns } from "./MtipytamequipamientoForm.vue?vue&type=template&id=38ec0483"
import script from "./MtipytamequipamientoForm.vue?vue&type=script&lang=js"
export * from "./MtipytamequipamientoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports